import React from 'react';
import { string } from 'prop-types';

export function DeliveryIcon({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" className={className}>
      <g fill="none">
        <path
          stroke="#32536A"
          d="M2.156 5.063L.762 12.13c-.153.776.336 1.37 1.13 1.37h10.216c.8 0 1.284-.59 1.13-1.37l-1.394-7.067c-.168-.85-1.033-1.563-1.9-1.563H4.056c-.868 0-1.732.711-1.9 1.563z"
        />
        <path
          stroke="#32536A"
          d="M4.535 3.5h4.93a5.595 5.595 0 0 0-.308-1.324C8.755 1.103 8.077.5 7 .5c-1.076 0-1.755.603-2.157 1.676A5.595 5.595 0 0 0 4.535 3.5z"
        />
        <path fill="#32536A" d="M4 4h1v1H4zM9 4h1v1H9z" />
      </g>
    </svg>
  );
}

DeliveryIcon.displayName = 'DeliveryIcon';
DeliveryIcon.propTypes = {
  className: string,
};

export function LocationIcon({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" className={className}>
      <path
        fill="#32536A"
        d="M6 13.5c3.333-2.744 5-4.87 5-7.379C11 3.234 8.757 1 6.455 1 3.243 1 1 3.234 1 6.121c0 3.767 3.614 6.596 5 7.379zM0 6c0-3.431 2.692-6 6-6 3.309 0 6 2.569 6 6 0 4.51-5.563 8.677-6 9-.436-.323-6-4.49-6-9zm6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
      />
    </svg>
  );
}

LocationIcon.displayName = 'LocationIcon';
LocationIcon.propTypes = {
  className: string,
};
